// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2EsfO","title":"FrontImage_title__3lmfg"};